// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3mxg2","overflowing":"ReadFullNote_overflowing__1sZVY"};